import { FC } from 'react'

const Card: FC<{ title: string; kv: { key: string; value: string }[] }> = ({ title, kv }) => {
  return (
    <div className="w-full max-w-300 rounded-xl laptop:rounded-3xl overflow-hidden">
      <div className="w-full h-16 pl-4 pt-18px laptop:h-32 laptop:pl-16 laptop:pt-39px bg-[linear-gradient(261deg,_#ffa365_-9%,#fc7216_131%)] bg-cover bg-50%_50% bg-blend-normal bg-no-repeat">
        <h2 className=" text-24 laptop:text-5xl font-semibold text-white">{title}</h2>
      </div>
      <div className="bg-white px-4 py-30px laptop:px-20 laptop:py-15 flex flex-col gap-y-5 laptop:gap-y-10">
        {kv.map((item) => (
          <div key={item.key}>
            <h3 className="text-14 laptop:text-2xl font-semibold text-black/90">{item.key}</h3>
            <p
              className="text-14 laptop:text-xl text-black/60 mt-2"
              dangerouslySetInnerHTML={{ __html: item.value }}
            ></p>
          </div>
        ))}
      </div>
    </div>
  )
}

const SectionFour: FC = () => {
  const cardData = [
    {
      title: 'BellaBot Trial Plan',
      kv: [
        { key: 'Trial Period:', value: 'Two weeks' },
        { key: 'Cost:', value: '$299' },
        {
          key: 'Trial Locations:',
          value:
            'Houston, Dallas, San Antonio, and Austin. Other areas beyond 100 miles will have additional shipping fees.At the end of the trial, installation and shipping are <span class="text-[#0066ff]">free</span> upon purchase or leasing. Otherwise, the robot will be returned at <span class="text-[#0066ff]">no extra cost</span>.',
        },
      ],
    },

    {
      title: 'How to Get BellaBot',
      kv: [
        { key: 'Step 1', value: 'Fill in the registration form to complete the application.' },
        {
          key: 'Step 2',
          value: `You’ll be contacted by our official retailer <span class="text-[#0066ff]">American Robotech</span> after we confirm your registration within 2-5 work days to confirm further details including trial start & end date, on-site working environment, trial tips, etc.
`,
        },
        {
          key: 'Step 3',
          value: `American Robotech will visit your place to deploy BellaBot and complete the initial settings. You can start enjoying the free trial service after the deployment and setup is complete.`,
        },
      ],
    },
  ]

  return (
    <section className="w-full bg-[#f2f3f5] flex flex-col gap-8 laptop:gap-16 items-center py-15 laptop:py-30 px-6 laptop:px-0">
      {cardData.map((data) => (
        <Card key={data.title} title={data.title} kv={data.kv} />
      ))}
    </section>
  )
}

export default SectionFour
